import script from "./TopTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTable.vue?vue&type=script&setup=true&lang=js"

import "./TopTable.vue?vue&type=style&index=0&id=9b4624ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b4624ae"]])

export default __exports__